import axios from "axios";
import { getAccessToken } from "../utils/authStorage";
import { renewTokens } from "./apiCalls";

export const authClient = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});

authClient.interceptors.request.use((config) => {
  const jwt = getAccessToken();
  if (jwt) {
    config.headers.authorization = `bearer ${jwt}`;
  }
  return config;
});

authClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    if (error.response?.status !== 401 || original?._retry) {
      return Promise.reject(error);
    }

    original._retry = true;

    try {
      const tokens = await renewTokens();
      original.headers = original.headers || {};
      original.headers.authorization = `bearer ${tokens.accessToken}`;
      return authClient(original);
    } catch (refreshError) {
      return Promise.reject(refreshError);
    }
  },
);
